export class RocketPartConfig {
    public id: number;
    public name: string;
    public screws?: number;
    public bolts?: number;
    public src: string;
    public frameWidth: number;
    public frameHeight: number;
}
export class RocketPart extends Phaser.GameObjects.Sprite {
    public id: number;
    public name: string;
    public screws?: number;
    public bolts?: number;

    constructor(scene: Phaser.Scene, x: number, y: number, config: RocketPartConfig) {
        super(scene, x, y, config.name, 1);

        this.id = config.id;
        this.name = config.name;
        this.screws = config.screws || 0;
        this.bolts = config.bolts || 0;

        this.setOrigin(0);
        this.setDepth(2);

        // Big wings - flip them so they don't cover other stuff
        if (this.id === 12) {
            this.setAngle(-90);
        }

        scene.children.bringToTop(this);
        scene.add.existing(this);
    }

    public static ROCKET_PARTS: RocketPartConfig[] = [
        { id: 1, name: "component1", screws: 4, bolts: 1, src: require("src/assets/qci/sprites/gameRocketRepair/component1.png"), frameWidth: 277, frameHeight: 208 },
        { id: 2, name: "component2", screws: 3, bolts: 2, src: require("src/assets/qci/sprites/gameRocketRepair/component2.png"), frameWidth: 206, frameHeight: 150 },
        { id: 3, name: "component3", screws: 6, bolts: 0, src: require("src/assets/qci/sprites/gameRocketRepair/component3.png"), frameWidth: 127, frameHeight: 143 },
        { id: 4, name: "component4", screws: 4, bolts: 0, src: require("src/assets/qci/sprites/gameRocketRepair/component4.png"), frameWidth: 192, frameHeight: 160 },
        { id: 5, name: "component5", screws: 2, bolts: 0, src: require("src/assets/qci/sprites/gameRocketRepair/component5.png"), frameWidth: 160, frameHeight: 170 },
        { id: 6, name: "component6", screws: 0, bolts: 1, src: require("src/assets/qci/sprites/gameRocketRepair/component6.png"), frameWidth: 162, frameHeight: 125 },
        { id: 7, name: "component7", screws: 4, bolts: 1, src: require("src/assets/qci/sprites/gameRocketRepair/component7.png"), frameWidth: 395, frameHeight: 91 },
        { id: 8, name: "component8", screws: 3, bolts: 0, src: require("src/assets/qci/sprites/gameRocketRepair/component8.png"), frameWidth: 425, frameHeight: 112 },
        { id: 9, name: "component9", screws: 5, bolts: 0, src: require("src/assets/qci/sprites/gameRocketRepair/component9.png"), frameWidth: 425, frameHeight: 170 },
        { id: 10, name: "component10", screws: 3, bolts: 0, src: require("src/assets/qci/sprites/gameRocketRepair/component10.png"), frameWidth: 191, frameHeight: 116 },
        { id: 11, name: "component11", screws: 0, bolts: 1, src: require("src/assets/qci/sprites/gameRocketRepair/component11.png"), frameWidth: 191, frameHeight: 78 },
        { id: 12, name: "component12", screws: 8, bolts: 0, src: require("src/assets/qci/sprites/gameRocketRepair/component12.png"), frameWidth: 330, frameHeight: 441 },
    ];

}



// WEBPACK FOOTER //
// ./src/games/RocketRepairGame/objects/RocketPart.ts